import * as React from 'react';
import { ComposableCard, GDSTagProps } from '@leagueplatform/genesis-core';
import { InternalOrExternalLink as Link } from '@leagueplatform/web-common-components';
import type { VisitCountCoverageCardProps } from '#types/coverage-detail-widget-cards.types.ts';

type VisitCountCardProps = VisitCountCoverageCardProps;

export function VisitCountCard({
  badgeLabel,
  badgeStatus = 'neutral',
  title,
  description,
  ctaIndicator,
  ctaLabel,
  href,
  onClick,
  headingLevel = '3',
}: VisitCountCardProps) {
  const isLink = !!href;
  // Genesis Core ComposableCard.CTASection expects the chevron to be 'disclosure'
  // We do not want a fallback indicator for visit count card.
  const indicator = ctaIndicator === 'chevron' ? 'disclosure' : ctaIndicator;

  const tags = React.useMemo(() => {
    if (badgeLabel) {
      return [
        {
          label: badgeLabel,
          category: badgeStatus,
          emphasis: 'subdued',
        } as GDSTagProps,
      ];
    }
    return undefined;
  }, [badgeLabel, badgeStatus]);

  return (
    <ComposableCard.Root backgroundColor="secondary" css={{ width: '100%' }}>
      <ComposableCard.Body
        heading={title}
        headingLevel={headingLevel}
        subheading={description}
        tags={tags}
      />
      {ctaLabel && (
        <ComposableCard.CTASection
          position="leading"
          firstCTA={{
            type: 'secondary',
            indicator,
            label: ctaLabel,
            ...(isLink && { as: Link, href }),
            onClick,
          }}
        />
      )}
    </ComposableCard.Root>
  );
}
